import { render, staticRenderFns } from "./DistributionTab.vue?vue&type=template&id=aa6b0bb2&scoped=true"
import script from "./DistributionTab.vue?vue&type=script&lang=js"
export * from "./DistributionTab.vue?vue&type=script&lang=js"
import style0 from "./DistributionTab.vue?vue&type=style&index=0&id=aa6b0bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6b0bb2",
  null
  
)

export default component.exports